import { defineComponent as _defineComponent } from 'vue'

import { CommunityTalkUserViewModel } from "@/viewModels/communityTalk/communityTalkUserViewModel";
import CommunityTalkUserNickNameProfilePic from "@/components/communityTalk/CommunityTalkUserNickNameProfilePic.vue";
import CommunityTalkUserReviewerAttributeAnswer from "@/components/communityTalk/CommunityTalkUserReviewerAttributeAnswer.vue";
import ReplyBadge from "@/components/communityTalk/reply/ReplyBadge.vue";
import CommunityTalkNewArrivalBadge from "./CommunityTalkNewArrivalBadge.vue";

interface Props {
	/**
	 * コミュニティトークユーザー情報。
	 */
	viewModel: CommunityTalkUserViewModel;

	/**
	 * 投稿日時。
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef

export default /*#__PURE__*/_defineComponent({
  props: {
    viewModel: { type: null, required: true },
    postDate: { type: String, required: true },
    newArrivalBadgeText: { type: String, required: true },
    newArrivalBadgeDisplayDays: { type: Number, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * コミュニティトークユーザー情報。
	 */
	viewModel: CommunityTalkUserViewModel;

	/**
	 * 投稿日時。
	 */
	postDate: string;

	/**
	 * 新着投稿バッジ文言
	 */
	newArrivalBadgeText: string;

	/**
	 * 新着投稿バッジ表示日数
	 */
	newArrivalBadgeDisplayDays: number;
}
/**
 * ユーザー情報。
 */



const __returned__ = { props, CommunityTalkUserNickNameProfilePic, CommunityTalkUserReviewerAttributeAnswer, ReplyBadge, CommunityTalkNewArrivalBadge }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})